export const fieldFragment = /* GraphQL */ `
  fragment fieldItem on Field {
    id
    key
    label
    value
    type
    organizationFieldsId
    organization {
      id
      name
    }
    metadata {
      key
      value
      type
    }
    translations(filter: $lang, limit: 100) {
      items {
        id
        label
        lang
        updatedAt
      }
    }
    options(filter: $optionFilter, limit: 10000) {
      items {
        id
        label
        value
        userID
        organizationID
        status
        metadata {
          key
          value
          type
        }
        optionOptionsId
        fieldOptionsId
        translations(filter: $lang, limit: 100) {
          items {
            id
            label
            lang
            updatedAt
          }
        }
        updatedAt
        options(filter: $optionFilter, limit: 10000) {
          items {
            id
            label
            value
            userID
            organizationID
            status
            metadata {
              key
              value
              type
            }
            optionOptionsId
            fieldOptionsId
            translations(filter: $lang, limit: 100) {
              items {
                id
                label
                lang
                updatedAt
              }
            }

            updatedAt
          }
        }
      }
    }
    updatedAt
  }
`
